module.exports = __webpack_public_path__ + "img/ip.a6ae3b73.png";